import { render, staticRenderFns } from "./select-tertiary.vue?vue&type=template&id=27118822&scoped=true"
import script from "./select-tertiary.vue?vue&type=script&lang=js"
export * from "./select-tertiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27118822",
  null
  
)

export default component.exports